import '~/js/modules/stickyNav';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

const images = Array.from(document.querySelectorAll('[data-order]'));
const numberParam = new URLSearchParams(document.location.search).get('scrollTo');

const scrollDown = () => {
  const scrollToElement = document.querySelector(`.image-card[data-order='${numberParam}']`);

  window.scrollTo({ top: scrollToElement.getBoundingClientRect().top - 176, behavior: 'smooth' });
};

if (numberParam !== null) {
  scrollDown();
}

const compare = (a, b) => {
  const numA = Number(a.dataset.order);
  const numB = Number(b.dataset.order);

  return numA - numB;
};

const sortedImages = images.sort(compare);

const newImageOrder = () => {
  sortedImages.forEach(el => {
    $('.gallery-images').append(el);
  });
};

newImageOrder();
